import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forceDownload, CERTIFICATE_REGULARITY } from '_/utils';
import { PROCESS_STATUS } from '@plataforma/utils';
import IconButton from '../IconButton';
import * as S from './DocumentDownloadStyles';

function DocumentDownload({
  type,
  onCopyDocumentLink,
  onDownloadDocument,
  quoteStatus
}) {
  const { t } = useTranslation();
  const labelButtonDownload =
    PROCESS_STATUS.quoteCanceled.id === quoteStatus.id
      ? 'Baixar apólice mãe'
      : t(`policyDetail.download.${type}.downloadLabel`);
  return (
    <>
      <S.BoxContainer>
        <S.IconContainer>
          <S.DocumentIcon />
        </S.IconContainer>
        <S.Content>
          <S.Title>{t(`policyDetail.download.${type}.title`)}</S.Title>
          <S.Text>{t('policyDetail.downloadText')}</S.Text>
          <S.Actions>
            <IconButton
              onClick={onDownloadDocument}
              icon={() => <S.DownloadIcon />}
            >
              {labelButtonDownload}
            </IconButton>
            <IconButton
              data-testid="copy-document-link"
              onClick={onCopyDocumentLink}
              icon={() => <S.LinkButtonIcon />}
            >
              {t('policyDetail.copyLink')}
            </IconButton>
          </S.Actions>
        </S.Content>
      </S.BoxContainer>
      <S.Button
        variant="outlined"
        size="big"
        onClick={() => {
          forceDownload(CERTIFICATE_REGULARITY, '', '_blank');
        }}
      >
        {t('policyDetail.certificateDownload')}
        <S.ChainIcon />
      </S.Button>
    </>
  );
}

DocumentDownload.propTypes = {
  type: PropTypes.string,
  onCopyDocumentLink: PropTypes.func,
  onDownloadDocument: PropTypes.func,
  quoteStatus: PropTypes.object
};

export default DocumentDownload;
